// pdfCache.js
import { pdfjs } from "react-pdf";
import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";

// PDF.js 워커 설정
// 🔹 pdf.js worker (CDN)
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;
// 캐시: { [pdfUrl]: Promise<PDFDocumentProxy> }
const pdfDocCache = {};

export async function getCachedPdfDocument(pdfUrl) {
    // 이미 캐시에 있으면, 그걸 반환
    if (pdfDocCache[pdfUrl]) {
        return pdfDocCache[pdfUrl];
    }
    // 없으면 다운로드 + 캐시에 저장
    pdfDocCache[pdfUrl] = pdfjs.getDocument(pdfUrl).promise;
    return pdfDocCache[pdfUrl];
}